// extracted by css-extract-rspack-plugin
export default {"trustedEmployerCheckIcon":"trusted-employer-check-icon--jDrYQTCAVhsrysUF"};